import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getUserBulkActivity} from 'src/openapi/admin/apis/BulkActivityLogApi';
import {useAppDispatch} from 'src/store/hooks';

import {bulkActivityLogsStateSelector} from '../slices/user-activity-log-state.slice';
import {
    bulkActivityLogsActions,
    bulkActivityLogsDataSelector,
    bulkActivityLogsResultSelector,
} from '../slices/user-activity-log.slice';

import type {ActivityLogCacheKeys} from '../typedef';
import type {BulkActivity} from 'src/openapi/admin/models/BulkActivity';


type Props = {
    userId: number,
};
export const useGetUserActivityLogTab = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: ActivityLogCacheKeys) => apiDispatch(getUserBulkActivity({
        pageNumber: cacheKeys.pagination.currentPage,
        pageSize: cacheKeys.pagination.pageSize,
        userId,
        sortDirection: cacheKeys.sortCriteria.direction,
    })), [userId, apiDispatch]);

    const setLoadedData = useCallback((
        response: BulkActivity,
        cacheKeys: ActivityLogCacheKeys,
    ) => {
        dispatch(bulkActivityLogsActions.onSuccess(({
            cacheKeys,
            totalCount: response.totalCount,
            data: response.actionLog,
        })));
    }, [dispatch]);

    return useCachedTable({
        dataSelector: bulkActivityLogsDataSelector,
        resultSelector: bulkActivityLogsResultSelector,
        stateSelector: bulkActivityLogsStateSelector,
        actions: bulkActivityLogsActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: true,
    });
};
